import React, { createContext, useContext, ReactNode } from 'react';
import { PermissionLabel, ViewerQuery } from 'client/generated/graphql';
import { useViewerPermissions } from 'client/modules/GraphQL/MumsAPI/viewerPermissions';

type PermissionsProviderValue = {
  permissionsForShow: PermissionLabel[] | null;
  authorizedShows: ViewerQuery['viewer']['authorizedShows'] | null;
};

const PermissionsContext = createContext<PermissionsProviderValue>({
  permissionsForShow: [],
  authorizedShows: [],
});

export const usePermissionsCtx = () => useContext(PermissionsContext);

export const PermissionsProvider = ({ children }: { children: ReactNode }) => {
  const { data } = useViewerPermissions();

  return (
    <PermissionsContext.Provider
      value={{
        permissionsForShow: data?.viewer.permissionsForShow || null,
        authorizedShows: data?.viewer.authorizedShows || null,
      }}
    >
      {children}
    </PermissionsContext.Provider>
  );
};
